import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ApiKey, ApiKeyCreate, ApiKeyFilter } from '../data/apiKey';

export function createApiKeyService(client: AxiosInstance) {
  return createCrudService<ApiKey, ApiKeyCreate, ApiKeyFilter>(
    client,
    '/identity/ApiKey',
    'id',
  );
}

export type ApiKeyService = CrudService<ApiKey, ApiKeyCreate, ApiKeyFilter>;
